import { FC } from 'react';
import { SocialMediaIcon, SocialMediaIconProps } from '@kontentino/ui';
import Card from 'app/modules/analytics/components/shared/Card';
import ReportComparisonBadge from './primitives/ReportComparisonBadge';
import ReportMetricComparisonCaption from './primitives/ReportMetricComparisonCaption';
import getSocialMediaTypeForBrandLogo from 'app/utils/getSocialMediaTypeForBrandLogo';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';

interface ReportMetricCardProps {
  title: string;
  value: string;
  badge?: number;
  caption?: string;
  platformPageTypes?: number[];
}

const ReportMetricCard: FC<ReportMetricCardProps> = ({
  title,
  value,
  badge,
  caption,
  platformPageTypes,
}) => {
  return (
    <Card className="tw-border tw-border-grayscale-20">
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-md tw-font-medium tw-text-grayscale-180">
          {title}
        </span>
        <div className="tw-flex tw-flex-col tw-gap-2 lg:tw-flex-row lg:tw-items-center">
          <span className="tw-text-lg tw-font-semibold tw-text-grayscale-180">
            {value}
          </span>
          {badge !== undefined && <ReportComparisonBadge percentage={badge} />}
        </div>
        <ReportMetricComparisonCaption caption={caption} />
      </div>
      {platformPageTypes && platformPageTypes.length > 0 && (
        <div className="tw-flex tw-items-center tw-gap-1 tw-rounded-md tw-bg-grayscale-10 tw-p-1">
          {platformPageTypes.map((pageType, index) => (
            <SocialMediaIcon
              key={`${pageType}-${index}`}
              size={getYtLogoGuidelineSize(20, pageType)}
              type={
                getSocialMediaTypeForBrandLogo(
                  pageType,
                ) as SocialMediaIconProps['type']
              }
              variant="plain"
            />
          ))}
        </div>
      )}
    </Card>
  );
};

export default ReportMetricCard;
